export default "__VITE_ASSET__CLt_T7tk__"